module.exports = __webpack_public_path__ + "img/logo22.aa80b281.jpg";